export default __webpack_public_path__ + "static/1-86f7838b3ee7e3a80313c5e054175517.svg";